'use es6';

import SeamlessImmutable from 'seamless-immutable';
import { LANGUAGES_FETCH } from 'DesignData/actions/ActionTypes';
export default ((state = SeamlessImmutable({}), action) => {
  switch (action.type) {
    case LANGUAGES_FETCH:
      {
        const {
          languages,
          error
        } = action;
        if (error || !languages) return state;
        return languages.reduce((hash, language) => {
          return hash.set(language.tag, language.displayName);
        }, state);
      }

    default:
      return state;
  }
});